/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';

export default declareEntity({
    entity: "usedScenarioWithScreenDefs",
    graphQL: "UsedScenarioWithScreenDefs",
    name: "Used Scenario",
    dynamoPrefix: 'org',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "Used Scenario ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        scenarioDef: {
            name: "Scenario Definitions",
            to: () => types['scenarioDefs'],
            type: "relation",
        },
        screenDef: {
            name: "Screen Definitions",
            to: () => types['scenarioScreenDefs'],
            type: "relation",
            inline: true,
            relativeTo: ["scenarioDef"]
        },
        usedScenario: {
            name: "Used Scenario",
            to: () => types['usedScenarios'],
            type: "relation",
        },
    }; },
    relations: (types) => { return {
    }; }
});
